import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { IconHeadphones } from "@tabler/icons-react";

const videoSrc = "/assets/images/videos/software.mp4"; // Single video source

const slides = [
  {
    id: 1,
    title: "Innovative IT solutions to help your business",
    subtitle: "Great IT field experience",
    description:
      "Our Goal Is to Become the Most Reputable Worldwide Provider of IT Solutions",
    img: "/assets/images/home-8-quality-service.png",
  },
  {
    id: 2,
    title: "Empower Your Business with Cutting-edge Tech",
    subtitle: "Expertise That Drives Innovation",
    description: "We deliver tailored IT solutions for global businesses.",
    img: "/assets/images/home-8-first-class-business.png",
  },
  {
    id: 3,
    title: "Transforming Ideas into Reality with IT",
    subtitle: "Your Trusted Partner in IT Excellence",
    description: "We innovate and execute the perfect IT solutions for you.",
    img: "/assets/images/home-23-problem-section.png",
  },
];

const Slider = () => {
  return (
    <section className="hero-2 position-relative" style={{ height: "520px" }}>
      {/* Background Video (Single Instance) */}
      <video
        autoPlay
        loop
        muted
        className="position-absolute top-0 start-0 w-100 h-100 object-cover"
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      {/* Overlay */}
      <div className="position-absolute top-0 start-0 w-100 h-100 bg-black opacity-50"></div>

      <Swiper
        modules={[Pagination, Autoplay]}
        slidesPerView={1}
        loop={true}
        autoplay={{ delay: 3000, disableOnInteraction: false }}
        pagination={{ clickable: true, el: ".hero2pagination" }}
        className="hero-swiper h-100"
      >
        {slides.map((slide) => (
          <SwiperSlide key={slide.id} className="position-relative h-100">
            <div className="container position-relative z-3">
              <div className="row g-3">
                <div className="col-12 col-lg-10 col-xl-7">
                  <div className="mt-5 pt-5">
                    <span className="h4 mb-2 d-block fw-semibold text-white mt-5">
                      {slide.subtitle}
                    </span>
                    <h3 className="h3 mb-2 text-white">{slide.title}</h3>
                    <p className="mb-5 fs-5 text-white">
                      {slide.description}
                    </p>
                    <div className="d-flex flex-wrap align-items-center gap-3 mb-4">
                      <a href="/contact" className="btn btn-outline-light">
                        Let's Talk Now
                        <span className="d-flex align-items-center justify-content-center rounded-circle bg-white p-1 text-n2">
                          <IconHeadphones className="text-primary w-6 h-6" />
                        </span>
                      </a>
                    </div>

                    <img
                      src={slide.img}
                      alt="slide image"
                      className="position-absolute bottom-0 end-0 z-1 d-none d-xl-block"
                      style={{ height: "450px" }} // Adjust as needed
                    />
                  </div>
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="hero2pagination"></div>
    </section>
  );
};

export default Slider;
